module.exports = __webpack_public_path__ + "static/organicwhitegeometric-23c22c8cfdf61a56e3f531193bea1136.jpeg";